'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_AppRouter$PrintRecipesAppPage(dateRange) {
  this.Sd = null;
  this.Sd = dateRange;
}
export { $c_Lmealorama_AppRouter$PrintRecipesAppPage as $c_Lmealorama_AppRouter$PrintRecipesAppPage };
$p = $c_Lmealorama_AppRouter$PrintRecipesAppPage.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_AppRouter$PrintRecipesAppPage;
/** @constructor */
function $h_Lmealorama_AppRouter$PrintRecipesAppPage() {
}
export { $h_Lmealorama_AppRouter$PrintRecipesAppPage as $h_Lmealorama_AppRouter$PrintRecipesAppPage };
$h_Lmealorama_AppRouter$PrintRecipesAppPage.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-90875037), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_AppRouter$PrintRecipesAppPage)) {
    var x = this.Sd;
    var x$2 = x$0.Sd;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 1;
});
$p.r = (function() {
  return "PrintRecipesAppPage";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.Sd;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lmealorama_AppRouter$PrintRecipesAppPage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jk)));
}
export { $isArrayOf_Lmealorama_AppRouter$PrintRecipesAppPage as $isArrayOf_Lmealorama_AppRouter$PrintRecipesAppPage };
var $d_Lmealorama_AppRouter$PrintRecipesAppPage = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_AppRouter$PrintRecipesAppPage, "mealorama.AppRouter$PrintRecipesAppPage", ({
  jk: 1,
  au: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_AppRouter$PrintRecipesAppPage as $d_Lmealorama_AppRouter$PrintRecipesAppPage };
//# sourceMappingURL=mealorama.-App-Router$-Print-Recipes-App-Page.js.map
